import React from "react";
import { evaluationType, OptionItem } from "../../../../../../API/evaluate";
import EvaluateRadio from "../EvaluateRadio";
import EvaluateCheckbox from "../EvaluateCheckbox";
import EvaluateRadioText from "../EvaluateRadioText";
import EvaluateTextarea from "../EvaluateTextarea";

interface Props {
    queTypeId: string;
    onSave: any;
    options: OptionItem[];
    _id?: string;
    stuText?: string;
    disabled: boolean;
}
const Index = ({
    queTypeId,
    onSave,
    options,
    disabled,
    stuText,
    ...restProps
}: Props) => {
    const props = {
        ...restProps,
        onSave,
        options,
        stuText,
        disabled
    };
    switch (queTypeId) {
        case evaluationType.radio:
            return <EvaluateRadio {...props} />;
        case evaluationType.checkbox:
            return <EvaluateCheckbox {...props} />;
        case evaluationType.radioText:
            return <EvaluateRadioText {...props} />;
        case evaluationType.textarea:
            return <EvaluateTextarea {...props} />;
        default:
            return <div />;
    }
};

export default Index;
